import styled from 'styled-components'

/** Horizontal-scroll wrapper around the table; takes the remaining panel height. */
export const TableScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  /* Hidden scrollbars — scrolling still works, the bars just don't render. */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    direction: rtl;
  }
`

export default TableScroll
